'use client'
import OtpInput from 'react-otp-input'
import customerService from '@/_service/customer.service'
import {
  Button,
  Center,
  HStack,
  IconButton,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import Countdown from '../../../Countdown'
import { LuChevronLeft, LuRotateCw } from 'react-icons/lu'
import { formatPhoneNumber } from '@/_utils/formatPhoneNumber'
import { FEATURED_BRANDS } from '@/_utils/Constants';

const OtpMobile = ({
  isError,
  isSuccess,
  phoneNumber,
  backToLogin,
  onSubmit,
}: {
  isError: boolean
  isSuccess: boolean
  phoneNumber: string
  backToLogin: () => void
  onSubmit: (data: any) => void
}) => {
  const [code, setCode] = useState('')
  const [isCountdown, setCountdown] = useState(true)

  const t = useTranslations()

  const onCountReset = () => {
    setCountdown(true)

    customerService
      .login({ phone: phoneNumber }, FEATURED_BRANDS.yaponamama)
      .then(() => {
        console.log({
          title: 'success.code_sent',
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
      })
      .catch(() => {
        console.log({
          title: t('errors.something_went_wrong'),
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      })

    setTimeout(() => {
      setCountdown(false)
    }, 60000)
  }

  return (
    <div>
      <HStack justify='space-between' my={3}>
        <IconButton
          variant='ghost'
          aria-label='Back'
          rounded='xl'
          onClick={backToLogin}
        >
          <LuChevronLeft color='var(--text-muted)' />
        </IconButton>
        <Text
          color='primary'
          rounded='xl'
          fontWeight={500}
          onClick={backToLogin}
        >
          {t('change_number')}
        </Text>
      </HStack>
      <Text
        fontSize='2xl'
        color={'text'}
        fontWeight={700}
        textAlign='center'
        mb={2}
      >
        {t('code_sent_to_number', {
          phoneNumber: formatPhoneNumber(String(phoneNumber)),
        })}
      </Text>
      <Stack gap={2} align='center'>
        <Center height='84px' flexDir='column'>
          <OtpInput
            value={code}
            onChange={(value) => {
              const sanitizedValue = value.replace(/[^0-9]/g, '')

              setCode(sanitizedValue)

              if (sanitizedValue.length === 6) {
                setTimeout(() => onSubmit(sanitizedValue), 0)
              }
            }}
            inputType='tel'
            containerStyle={{
              display: 'flex',
              gap: '8px',
            }}
            numInputs={6}
            shouldAutoFocus
            inputStyle={{
              backgroundColor: 'var(--bg-default)',
              color: 'var(--text-default)',
              width: '40px',
              height: '56px',
              fontSize: '20px',
              borderRadius: '8px',
              border: isError
                ? '1px solid red'
                : isSuccess
                  ? '1px solid green'
                  : undefined,
              textAlign: 'center',
            }}
            renderInput={(props) => <Input variant={'subtle'} {...props} />}
          />

          {isError && (
            <Text color='red.solid' fontWeight={500} mt={2}>
              {t('invalid_code_entered')}
            </Text>
          )}
        </Center>
        {isCountdown ? (
          <Center
            justifyContent={'center'}
            flexDirection={'column'}
            maxW={'250px'}
          >
            <Text textAlign={'center'} color={'text.muted'}>
              {t('send_another_code')}{' '}
              <Countdown value={60} onTimeout={() => setCountdown(false)} />
            </Text>
          </Center>
        ) : (
          <Button
            size='lg'
            color='primary'
            variant='ghost'
            textTransform='none'
            onClick={() => !isCountdown && onCountReset()}
          >
            <LuRotateCw /> {t('resend')}
          </Button>
        )}
      </Stack>
    </div>
  )
}

export default OtpMobile
